export default "/images/test-img.jpg?b19e11b4f34c6dfff1f9e7e34a05476c";